import { useState, useEffect } from 'react';

export function useInvoiceForm() {
    const [items, setItems] = useState([
        {
            itemName: '',
            itemPrice: '',
            itemQuantity: '',
        },
    ]);

    const [formData, setFormData] = useState({
        invoiceNumber: '',
        creationDate: '',
        startDate: '',
        validityDate: '',
        dueDate: '',
        taxEventDate: '',
        receiverName: '',
        receiverIdNumber: '',
        receiverCity: '',
        receiverMol: '',
        receiverAddress: '',
        receiverVatNumber: '',
        receiverPhoneNumber: '',
        scheduleType: "MONTHLY",
        interval: 1,
        nextInvoiceDate: '',
        paymentMethod: "CASH",
        issuerBankDetailsId: '',
        items: items,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = {
                ...prev,
                [name]: value,
            };
            if (name === 'paymentMethod' && value === 'CASH') {
                updated.issuerBankDetailsId = '';
            }
            return updated;
        });
    };

    const handleItemInputChange = (e, index) => {
        const { name, value } = e.target;
        setItems((prevItems) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = {
                ...updatedItems[index],
                [name]: value,
            };
            return updatedItems;
        });
    };

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            items: items,
        }));
    }, [items]);

    const addItemDiv = () => {
        setItems((prevItems) => [
            ...prevItems,
            {
                itemName: '',
                itemPrice: '',
                itemQuantity: '',
            },
        ]);
    };

    const removeItemDiv = (index) => {
        setItems((prevItems) => prevItems.filter((_, i) => i !== index));
    };

    const handleLoadInvoiceToForm = (invoice) => {
        setFormData({
            invoiceNumber: invoice.invoiceNumber || '',
            creationDate: invoice.creationDate || '',
            startDate: invoice.startDate || '',
            validityDate: invoice.validityDate || '',
            dueDate: invoice.dueDate || '',
            taxEventDate: invoice.taxEventDate || '',
            receiverName: invoice.receiverName || '',
            receiverIdNumber: invoice.receiverIdNumber || '',
            receiverCity: invoice.receiverCity || '',
            receiverMol: invoice.receiverMol || '',
            receiverAddress: invoice.receiverAddress || '',
            receiverVatNumber: invoice.receiverVatNumber || '',
            receiverPhoneNumber: invoice.receiverPhoneNumber || '',
            scheduleType: invoice.scheduleType || 'MONTHLY',
            interval: invoice.interval || 1,
            nextInvoiceDate: invoice.nextInvoiceDate || '',
            paymentMethod: invoice.paymentMethod || 'CASH',
            issuerBankDetailsId: invoice.issuerBankDetails ? invoice.issuerBankDetails.id : '',
            items: invoice.items || [],
        });
        setItems(invoice.items || []);
    };

    return {
        formData,
        items,
        handleInputChange,
        handleItemInputChange,
        addItemDiv,
        removeItemDiv,
        handleLoadInvoiceToForm,
    };
}
